import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";
import SellerSidebar from "./common/SellerSidebar";
import ProfileSidebar from "../pages/common/ProfileSidebar";

const data = [
  { month: "Jan", sales: 2 },
  { month: "Feb", sales: 3 },
  { month: "Mar", sales: 5 },
  { month: "Apr", sales: 3.5 },
  { month: "May", sales: 4 },
  { month: "Jun", sales: 1.8 },
  { month: "Jul", sales: 2.5 },
  { month: "Aug", sales: 4 },
  { month: "Sep", sales: 2 },
  { month: "Oct", sales: 2.6 },
  { month: "Nov", sales: 2 },
  { month: "Dec", sales: 2.5 },
];

const SellerDashboard = () => {
  const [orders, setOrders] = useState([
    {
      id: 1,
      product: "Woolen Clothes for elders",
      date: "Aug, 28 2024 02:28:22 PM",
      quantity: 2,
      amount: "200.00 USD",
      payment: "Card",
      status: "Confirmed",
    },
    {
      id: 2,
      product: "Woolen Clothes for elders",
      date: "Aug, 28 2024 02:28:22 PM",
      quantity: 2,
      amount: "200.00 USD",
      payment: "Bank",
      status: "Confirmed",
    },
    {
      id: 3,
      product: "Woolen Clothes for elders",
      date: "Aug, 28 2024 02:28:22 PM",
      quantity: 5,
      amount: "200.00 USD",
      payment: "QR",
      status: "Pending",
    },
  ]);

  // Hooks for table functionality
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [filterStatus, setFilterStatus] = useState("all");

  // Sorting function
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Filter orders based on status
  const filteredOrders = orders.filter((order) => {
    if (filterStatus === "all") return true;
    return order.status.toLowerCase() === filterStatus.toLowerCase();
  });

  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortConfig.key) {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
    }
    return 0;
  });

  // Limit to 8 orders for display
  const currentOrders = sortedOrders.slice(0, 8);

  // View All functionality
  const handleViewAll = () => {
    // You can replace this with your actual orders page route
    window.location.href = "/orders"; // or use React Router: navigate('/orders')
  };

  // Get total orders count
  const totalOrders = orders.length;

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">Dashboard</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Store
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              {/* Dashboard Details*/}
              <div className="col-lg-9">
                <div className="form_boxx profilss ">
                  {/* Cards */}
                  <div className="form_boxx Impact">
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/wallet_s_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Total Sales</p>
                            <h6>3,000.0 USD</h6>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/wallet_s_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Total Orders</p>
                            <h6> 2 </h6>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/calender_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Pending Payments</p>
                            <h6> 5 </h6>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/calender_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Total Earning</p>
                            <h6> 3,000.0 USD </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Chart */}
                  <div className="form_arar mt-4">
                    <div className="chart-card">
                      <div className="chart-header d-flex justify-content-between">
                        <h3 className="chart-title">Sales Report</h3>

                        <div className="chart-actions">
                          <select
                            className="chart-select"
                            defaultValue="Monthly"
                          >
                            <option>Monthly</option>
                            <option>Quarterly</option>
                            <option>Yearly</option>
                          </select>
                          {/* Optional icons: */}
                          <button
                            className="chart-icon-btn"
                            aria-label="Download"
                          >
                            <img src="svg/download.svg" alt="download" />
                          </button>
                          <button className="chart-icon-btn" aria-label="More">
                            ⋮
                          </button>
                        </div>
                      </div>

                      <div className="chart-body">
                        <ResponsiveContainer width="100%" height={360}>
                          <BarChart
                            data={data}
                            margin={{
                              top: 10,
                              right: 20,
                              bottom: 10,
                              left: 20,
                            }}
                            barCategoryGap={20}
                          >
                            <CartesianGrid stroke="#e9ecef" vertical={false} />
                            <XAxis
                              dataKey="month"
                              tick={{ fill: "#6c757d", fontSize: 14 }}
                              tickLine={false}
                              axisLine={{ stroke: "#e9ecef" }}
                            />
                            <YAxis
                              domain={[0, 5]}
                              ticks={[0, 1, 2, 3, 4, 5]}
                              tick={{ fill: "#6c757d", fontSize: 14 }}
                              tickLine={false}
                              axisLine={{ stroke: "#e9ecef" }}
                              label={{
                                value: "USD",
                                angle: -90,
                                position: "insideLeft",
                                offset: 10,
                                style: { fill: "#495057", fontWeight: 600 },
                              }}
                            />
                            <Tooltip
                              cursor={{ fill: "rgba(0,0,0,0.03)" }}
                              contentStyle={{
                                borderRadius: 8,
                                border: "1px solid #e9ecef",
                                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                              }}
                            />
                            <Bar
                              dataKey="sales"
                              fill="#4AA5A5"
                              radius={[8, 8, 0, 0]}
                              maxBarSize={28}
                            />
                          </BarChart>
                        </ResponsiveContainer>

                        <div className="x-axis-title">Months</div>
                      </div>
                    </div>
                  </div>

                  {/* Recent orders List */}
                  <div className="form_arar mt-4">
                    <div className="d-flex justify-content-between items-center mb-4">
                      <h5 className="recent-orders-title">
                        Recent Orders ({totalOrders})
                      </h5>
                      <button className="view-all-link" onClick={handleViewAll}>
                        View All
                      </button>
                    </div>

                    <div className="orders-table-container">
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">S. No.</th>
                            <th className="header-cell">Product Name</th>
                            <th className="header-cell">Date</th>
                            <th className="header-cell">Quantity</th>
                            <th className="header-cell">Amount</th>
                            <th className="header-cell">Payment</th>
                            <th className="header-cell">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentOrders.map((order, index) => (
                            <tr key={order.id} className="table-row">
                              <td className="table-cell serial-number">
                                {index + 1}.
                              </td>
                              <td className="table-cell product-name">
                                {order.product}
                              </td>
                              <td className="table-cell date">{order.date}</td>
                              <td className="table-cell quantity">
                                {order.quantity.toString().padStart(2, "0")}
                              </td>
                              <td className="table-cell amount">
                                {order.amount}
                              </td>
                              <td className="table-cell payment">
                                {order.payment}
                              </td>
                              <td
                                className={`table-cell status ${order.status.toLowerCase()}`}
                              >
                                {order.status}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Bulk Products */}
                  <div className=" my_profiless mt-4 text-white ">
                    <div className="d-flex justify-content-between items-center">
                      <div>
                        <h5 className="text-white ">
                          {" "}
                          Bulk Upload your Products
                        </h5>
                        You can bulk upload your products by uploading your
                        Excel or CSV files
                      </div>
                      <div className="proceed-btn-wrapper">
                        <Link to="/mall-dashboard/bulk-product">
                          <button className="pt-2 pb-2">PROCEED</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SellerDashboard;
